import { Link, List, ListItem, Typography, Box, Container, createTheme, ThemeProvider } from '@mui/material';
import * as CommonLicenseProps from './CommonLicenseProps';

//Custom theme using createTheme
const theme = createTheme(
  {
    typography:
    {
      fontFamily: "Inter", // Change the default font-family
    }
  });

const CopyrightLicenseAgreementCustomer = () => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Container maxWidth="lg">
          <Box sx={CommonLicenseProps.pageProps}>
            {/* Page Header */}
            <Typography sx={CommonLicenseProps.pageTitleProps}>
              Copyright License Agreement (Customer)
            </Typography>

            {/* Introduction */}
            <Typography sx={CommonLicenseProps.normalParaProps}>
              This COPYRIGHT LICENSE AGREEMENT (the “<Typography sx={CommonLicenseProps.emphasizedText}>Agreement</Typography>”) is made by and between you (“<Typography sx={CommonLicenseProps.emphasizedText}>Customer</Typography>”) and Saagas.AI Inc. a Delaware corporation (“<Typography sx={CommonLicenseProps.emphasizedText}>Saagas</Typography>”).
            </Typography>
            <Typography sx={CommonLicenseProps.normalParaProps}>
              THIS AGREEMENT CONTAINS IMPORTANT INFORMATION ABOUT YOUR RIGHTS. BY CLICKING “YES” AT THE BOTTOM OF THIS AGREEMENT YOU HEREBY ACCEPT AND AGREE TO BE
              BOUND AND TO ABIDE BY THE PROVISIONS IN THIS AGREEMENT AS WELL AS SAAGAS’S TERMS OF USE WHICH ARE INCORPORATED BY REFERENCE HEREIN.
            </Typography>

            {/* Recitals */}
            <Typography sx={CommonLicenseProps.sectionHeadingProps}>
              Recitals
            </Typography>
            <List sx={CommonLicenseProps.upperAlphaListProps}>
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.bulletParaProps}>
                  WHEREAS Saagas uses machine-learning technology to capture artistic styles and features from pre-existing artwork to generate derivative
                  artwork which Saagas then licenses to its customers for personal and/or commercial use; and
                </Typography>
              </ListItem>
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.bulletParaProps}>
                  WHEREAS Saagas has the right to license the Derivative Work (as defined below) and wishes to grant to Customer a license under those rights
                  and Customer wishes to obtain a license to the Derivative Work for the uses and purposes described herein each subject to the terms and
                  conditions set forth herein.
                </Typography>
              </ListItem>
            </List>

            {/* Agreement */}
            <Typography sx={CommonLicenseProps.sectionHeadingProps}>
              Agreement
            </Typography>
            <Typography sx={CommonLicenseProps.normalParaProps}>
              NOW THEREFORE in consideration of the mutual covenants terms and conditions set forth herein and for other good and valuable consideration the
              receipt and sufficiency of which are hereby acknowledged the parties agree as follows:
            </Typography>

            <List sx={CommonLicenseProps.decimalListProps}>
              {/* Section 1 */}
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  License
                </Typography>

                <List sx={CommonLicenseProps.decimalListProps}>
                  {/* Subsection 1.1 */}
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Grant of Rights
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Subject to the terms and conditions of this Agreement Saagas hereby grants to Customer during the Term (as defined below):
                    </Typography>
                    <List sx={CommonLicenseProps.lowerAlphaListProps}>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          Personal Use: a non-exclusive non-transferable non-sublicensable license anywhere in the world (the “<Typography sx={CommonLicenseProps.emphasizedText}>Territory</Typography>”) solely to display and
                          reproduce the Derivative Work for personal non-commercial use.
                        </Typography>
                      </ListItem>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          Commercial Use: an exclusive non-transferable non-sublicensable license anywhere in the world (the “<Typography sx={CommonLicenseProps.emphasizedText}>Territory</Typography>”) solely to reproduce
                          display transmit distribute and create derivative works based on the Derivative Work for personal and/or commercial use.
                        </Typography>
                      </ListItem>
                    </List>
                  </ListItem>

                  {/* Subsection 1.2 */}
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      The “<Typography sx={CommonLicenseProps.emphasizedText}>Derivative Work</Typography>”
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      means artwork delivered to Customer pursuant to this Agreement that was generated by Saagas through machine-learning technology intended to
                      capture the styles and features of underlying artwork by one or more artists (collectively “<Typography sx={CommonLicenseProps.emphasizedText}>Artist</Typography>”).
                    </Typography>
                  </ListItem>

                  {/* Subsection 1.3 */}
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      No Right to Underlying Artwork
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Notwithstanding any other provisions of this Agreement to the contrary nothing in this Agreement will be deemed to be a grant by Saagas of a
                      license sublicense or other grant of a right to Customer to use any underlying artwork of Artist (e.g. underlying artwork).
                    </Typography>
                  </ListItem>

                  {/* Subsection 1.4*/}
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Reservation of Rights
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Saagas reserves all rights not expressly granted to Customer under this Agreement. No use by Saagas of the Derivative Work in any medium or
                      manner will be deemed to interfere with the limited permissions made to Customer by Saagas herein.F{' '}
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>

              {/* Section 2 */}
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Usage of the Derivative Work
                </Typography>
                <Typography sx={CommonLicenseProps.normalParaProps}>
                  Notwithstanding any other provision to the contrary contained in this Agreement:
                </Typography>
                <List sx={CommonLicenseProps.decimalListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Copyright Notices
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Customer shall ensure that its use of the Derivative Work is at all times marked with the appropriate
                      copyright and attribution notices specified by Saagas in the order and manner provided by Saagas (including attribution with respect to Artist).
                      Customer shall abide by the copyright laws and what are considered to be sound practices for copyright notice provisions in the Territory.
                      Customer shall not use any copyright notices that conflict with confuse or negate the notices Saagas provides and requires hereunder.
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>

              {/* Section 3 */}
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Payment
                </Typography>
                <Typography sx={CommonLicenseProps.normalParaProps}>
                  As consideration in full for the rights granted herein Customer shall pay Saagas the fee as set forth on the Licensing Fee Schedule attached
                  hereto as Exhibit A in accordance with the terms and conditions set forth on the Licensing Fee Schedule.
                </Typography>
              </ListItem>

              {/* Section 4 */}
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Ownership and Protection
                </Typography>
                <List sx={CommonLicenseProps.decimalListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Acknowledgment of Ownership
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Except for the licenses expressly granted to Customer in this Agreement Customer acknowledges that all right title and interest in and to the
                      Derivative Work are and will remain with Saagas. If Customer acquires any rights in the Derivative Work by operation of law or otherwise
                      Customer hereby irrevocably assigns such rights to Saagas without further action by either party. Customer agrees not to dispute or challenge or
                      assist any person or entity in disputing or challenging Saagas’s rights in and to the Derivative Work.
                    </Typography>
                  </ListItem>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Protection of the Derivative Work
                    </Typography>
                    <List sx={CommonLicenseProps.lowerAlphaListProps}>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                          Notification
                        </Typography>
                        <Typography sx={CommonLicenseProps.normalParaProps}>
                          Customer shall immediately notify Saagas in writing with reasonable detail of any: (i) actual suspected or
                          threatened infringement of the Derivative Work; (ii) actual suspected or threatened claim that use of the Derivative Work infringes the
                          rights of any third party; or (iii) other actual suspected or threatened claim to which the Derivative Work may be subject.
                        </Typography>
                      </ListItem>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                          Actions
                        </Typography>
                        <Typography sx={CommonLicenseProps.normalParaProps}>
                          With respect to any of the matters listed in Section 4.2(a): (i) Saagas has exclusive control over and conduct of
                          all claims and proceedings; (ii) Customer shall provide Saagas with all assistance that Saagas may reasonably require in the conduct of any
                          claims or proceedings; and (iii) Saagas shall bear the cost of any proceedings and will be entitled to retain all sums recovered in any
                          action for its own account.
                        </Typography>
                      </ListItem>
                    </List>
                  </ListItem>
                </List>
              </ListItem>

              {/* Section 5 */}
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Representations and Warranties
                </Typography>
                <List sx={CommonLicenseProps.decimalListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Mutual Representations and Warranties. Each party represents and warrants to the other party that:
                    </Typography>
                    <List sx={CommonLicenseProps.lowerAlphaListProps}>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          it has the full right power and authority to enter into this Agreement and to perform its obligations hereunder; and
                        </Typography>
                      </ListItem>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          when executed and delivered by such party this Agreement will constitute the legal valid and binding obligation of such party enforceable
                          against such party in accordance with its terms.
                        </Typography>
                      </ListItem>
                    </List>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Saagas’s Representations and Warranties
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Saagas represents and warrants solely to and for the benefit of Customer that it has the right to license the Derivative Work in connection with
                      Customer’s uses permitted hereunder in the Territory.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Customer’s Representations and Warranties
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Customer represents and warrants that:
                    </Typography>
                    <List sx={CommonLicenseProps.lowerAlphaListProps}>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          Customer will not engage or participate in any activity or course of action that could diminish or tarnish the image or reputation of the
                          Derivative Work or Saagas or cause confusion as to the ownership of the Derivative Work;
                        </Typography>
                      </ListItem>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          Customer’s use of the Derivative Work will not infringe misappropriate or otherwise violate the intellectual property or other rights of any
                          third party or violate any applicable regulation or law; and
                        </Typography>
                      </ListItem>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          Customer has read understands and will at all times adhere to Saagas’s Terms of Use, available <Link href="/terms-of-use" target="_blank">here</Link>, which are incorporated by reference herein.
                        </Typography>
                      </ListItem>
                    </List>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Disclaimer of Representations and Warranties
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      EXCEPT AS EXPRESSLY PROVIDED IN THIS SECTION 5 SAAGAS HEREBY DISCLAIMS ALL WARRANTIES WHETHER EXPRESS IMPLIED STATUTORY OR OTHERWISE WITH
                      RESPECT TO THE DERIVATIVE WORK INCLUDING SPECIFICALLY ANY IMPLIED WARRANTY OF MERCHANTABILITY FITNESS FOR A PARTICULAR PURPOSE TITLE
                      NON-INFRINGEMENT AND WARRANTIES THAT MAY ARISE OUT OF COURSE OF DEALING COURSE OF PERFORMANCE USAGE OR TRADE PRACTICE.
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>

              {/* Section 6 */}
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Indemnification
                </Typography>
                <List sx={CommonLicenseProps.decimalListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Customer Indemnification
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Customer shall indemnify defend and hold harmless Saagas and its officers directors employees agents affiliates successors permitted assigns and
                      licensees (each an “<Typography sx={CommonLicenseProps.emphasizedText}>Indemnified Party</Typography>”) from and against any losses damages liabilities deficiencies claims actions judgments settlements
                      interest awards penalties fines costs or expenses of whatever kind including reasonable attorneys’ fees and the cost of enforcing any right to
                      indemnification hereunder and the cost of pursuing any insurance providers arising out of or in connection with any third-party claim suit
                      action or proceeding (each a “<Typography sx={CommonLicenseProps.emphasizedText}>Third-Party Claim</Typography>”) relating to any actual or alleged breach by Customer of its representations warranties
                      covenants or other obligations hereunder.{' '}
                    </Typography>
                  </ListItem>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Indemnification Procedure
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Each party shall notify the other party on becoming aware of a Third-Party Claim under this Section 6. Customer shall promptly assume control of
                      the defense and investigation of the Third-Party Claim with counsel reasonably acceptable to Saagas and Saagas shall reasonably cooperate with
                      Customer in connection therewith in each case at Customer’s sole cost and expense. Saagas may participate in the defense of such Third-Party
                      Claim with counsel of its own choosing and at its own cost and expense. Customer will not settle any Third-Party Claim on any terms or in any
                      manner that adversely affects the rights of any Indemnified Party without Saagas’s prior written consent. If Customer fails or refuses to assume
                      control of the defense of such Third-Party Claim the Indemnified Party will have the right but no obligation to defend against such Third-Party
                      Claim including settling such Third-Party Claim in each case in such manner and on such terms as the Indemnified Party may deem appropriate.
                      Neither Saagas’s failure to perform any obligation under this Section 6.2 nor any Indemnified Party’s act or omission in the defense or
                      settlement of any such Third-Party Claim will relieve Customer of its obligations under this Section 6.2 except to the extent that Customer can
                      demonstrate that it has been materially prejudiced as a result thereof.{' '}
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>

              {/* Section 7 */}
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Term and Termination
                </Typography>
                <List sx={CommonLicenseProps.decimalListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Term
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      This Agreement commences upon your purchase of a license of any Derivative Work from Saagas and will remain in force until terminated as
                      provided herein (the “<Typography sx={CommonLicenseProps.emphasizedText}>Term</Typography>”).
                    </Typography>
                  </ListItem>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Termination by Saagas
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Saagas may terminate this Agreement at any time without cause by providing written notice to Customer.
                    </Typography>
                  </ListItem>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Termination for Cause
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Customer may terminate this Agreement on written notice to Saagas if Saagas materially breaches this Agreement and fails to cure such breach
                      within 20 days after receiving written notice thereof.
                    </Typography>
                  </ListItem>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Effect of Termination
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      On the expiration or termination of this Agreement for any reason, all rights licensed under this Agreement will revert immediately to Saagas andCustomer shall cause to be inactivated and erased all digital copies of the Derivative Work in its control and possession anddestroy any tangible copies of the Derivative Work. Upon Saagas’s request, Customer shall provide an affidavit to Saagas attesting to such erasure or destruction.
                    </Typography>
                  </ListItem>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Surviving Rights
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Any rights or obligations of the parties in this Agreement which by their nature should survive termination or expiration of this Agreement
                      will survive any such termination or expiration including the rights and obligations set forth in this Section 7 and Section 3, Section 4,
                      Section 5, Section 6, Section 8, and Section 9.
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>

              {/* Section 8 */}
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Remedies
                </Typography>
                <List sx={CommonLicenseProps.decimalListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Equitable Relief
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Customer acknowledges that a breach by Customer of this Agreement may cause Saagas irreparable damages for which an award of damages would not
                      be adequate compensation and agrees that in the event of such breach or threatened breach Saagas will be entitled to seek equitable relief
                      including a restraining order orders for a preliminary or permanent injunction specific performance and any other relief that may be available
                      from any court in addition to any other remedy to which Saagas may be entitled at law or in equity. Such remedies are not exclusive but are in
                      addition to all other remedies available at law or in equity subject to any express exclusions or limitations in this Agreement to the
                      contrary.
                    </Typography>
                  </ListItem>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Limitation of Liability
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW SAAGAS WILL NOT BE LIABLE UNDER OR IN CONNECTION WITH THIS AGREEMENT FOR ANY CONSEQUENTIAL
                      INCIDENTAL INDIRECT EXEMPLARY SPECIAL PUNITIVE OR ENHANCED DAMAGES OR FOR ANY LOSS OF ACTUAL OR ANTICIPATED PROFITS (REGARDLESS OF HOW THESE
                      ARE CLASSIFIED AS DAMAGES) WHETHER ARISING OUT OF BREACH OF CONTRACT TORT (INCLUDING NEGLIGENCE) OR OTHERWISE (INCLUDING THE ENTRY INTO
                      PERFORMANCE OR BREACH OF THIS AGREEMENT) REGARDLESS OF WHETHER SUCH DAMAGE WAS FORESEEABLE AND WHETHER SAAGAS HAS BEEN ADVISED OF THE
                      POSSIBILITY OF SUCH DAMAGES.
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>

              {/* Section 9 */}
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  General.
                </Typography>
                <List sx={CommonLicenseProps.decimalListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Interpretation
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      For purposes of this Agreement: (a) the words “include” “includes” and “including” are deemed to be followed by the words “without
                      limitation”; (b) the word “or” is not exclusive; and (c) the words “herein” “hereof” “hereby” “hereto” and “hereunder” refer to this Agreement
                      as a whole. This Agreement is intended to be construed without regard to any presumption or rule requiring construction or interpretation
                      against the party drafting an instrument or causing any instrument to be drafted.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Binding Agreement
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      This Agreement shall be binding upon and shall inure to the benefit of the successors and assigns of the respective parties hereto.{' '}
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Entire Agreement
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      This Agreement together with any exhibits or other attachments (which are hereby expressly incorporated into this Agreement) is the sole and
                      entire agreement of the parties with respect to the subject matter herein and supersedes all prior and contemporaneous understandings
                      agreements representations and warranties whether written or oral with respect to such subject matter.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Severability
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      If any term or provision of this Agreement is invalid illegal or unenforceable in any jurisdiction such invalidity illegality or
                      unenforceability will not affect the enforceability of any other term or provision of this Agreement or invalidate or render unenforceable
                      such term or provision in any other jurisdiction.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Assignment
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Customer shall not assign any of its rights or delegate any of its obligations under this Agreement without the prior written consent of
                      Saagas. Any purported assignment or delegation in violation of this Section 9.5 is null and void. Saagas may freely assign or otherwise
                      transfer any of its rights or delegate any of its obligations under this Agreement. This Agreement is binding upon and inures to the benefit
                      of the parties hereto and their respective permitted successors and assigns.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Governing Law
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      This Agreement and all matters arising out of or relating to this Agreement are governed by and construed in accordance with the laws of the
                      State of Washington without giving effect to any conflict of laws provisions thereof that would require or permit the application of the laws
                      of a different jurisdiction.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Arbitration
                    </Typography>
                    <List sx={CommonLicenseProps.lowerAlphaListProps}>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          Except as otherwise provided in Section ‎9.6‎(d), any dispute, controversy, or claim arising out of the subject matter of this Agreement
                          will be settled by arbitration before a single arbitrator in Seattle, Washington.
                        </Typography>
                      </ListItem>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          The arbitration will be initiated by filing a claim with American Arbitration Association and will be conducted by an arbitrator
                          knowledgeable in business law in accordance with the then-current rules of American Arbitration Association.
                        </Typography>
                      </ListItem>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          The resolution of any dispute, controversy, or claim as determined by the arbitrator will be binding on the parties. Judgment on the award
                          of the arbitrator may be entered by any party in any court having jurisdiction.
                        </Typography>
                      </ListItem>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          A party may seek from a court an order to compel arbitration, or any other interim relief or provisional remedies pending an arbitrator’s
                          resolution of any dispute, controversy, or claim. Any such action, suit, or proceeding will be litigated in courts located in Seattle,
                          Washington.
                        </Typography>
                      </ListItem>
                      <ListItem sx={CommonLicenseProps.listItemProps}>
                        <Typography sx={CommonLicenseProps.bulletParaProps}>
                          For the purposes set forth in Section 9.6(d), each party consents and submits to the jurisdiction of any local, state, or federal court
                          located in Seattle, Washington.
                        </Typography>
                      </ListItem>
                    </List>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Contra Proferentem
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      The doctrine of contra proferentem shall not apply to this Agreement. Any rule of law or any legal decision that would require interpretation
                      of any claimed ambiguities in this Agreement against the drafting party has no application and is expressly waived.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Relationship of the Parties
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      Nothing contained in this Agreement will be construed as creating any agency partnership joint venture or other form of joint enterprise
                      employment or fiduciary relationship between the parties and neither party has authority to contract for or bind the other party in any manner
                      whatsoever.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      No Third-Party Beneficiaries
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      This Agreement is for the sole benefit of the parties hereto and their respective successors and permitted assigns and nothing herein express
                      or implied is intended to or will confer upon any third party any legal or equitable right benefit or remedy of any nature whatsoever under or
                      by reason of this Agreement.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Amendment and Modification
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      No amendment or modification to this Agreement is effective unless it is in writing and signed by an authorized representative of each party.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Waiver.
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      No waiver by any party of any of the provisions hereof will be effective unless explicitly set forth in writing and signed by the waiving
                      party. No waiver by any party will operate or be construed as a waiver of any failure breach or default not expressly identified by such
                      written waiver whether of a similar or different character and whether occurring before or after that waiver. Except as otherwise set forth in
                      this Agreement no failure to exercise or delay in exercising any right remedy power or privilege arising from this Agreement will operate or
                      be construed as a waiver thereof. No single or partial exercise of any right remedy power or privilege hereunder will preclude any other or
                      further exercise thereof or the exercise of any other right remedy power or privilege.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Attorneys’ Fees
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      In the event that any claim suit action or proceeding is instituted or commenced by either party hereto against the other party arising out of
                      or related to this Agreement the prevailing party will be entitled to recover its reasonable attorneys’ fees and court costs from the
                      non-prevailing party.
                    </Typography>
                  </ListItem>

                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Acceptance of Binding Agreement
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      BY USING THE SERVICE YOU ARE INDICATING THAT YOU HAVE READ AND HEREBY AGREE TO BE BOUND BY ALL OF THE TERMS OF THIS AGREEMENT.
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>
            </List>
          </Box>

          <Box sx={{ mt: 6, pt: 4, borderTop: '1px solid #e0e0e0' }}>
            <Typography sx={CommonLicenseProps.sectionHeadingProps}>
              Exhibit A
            </Typography>
            <Typography sx={CommonLicenseProps.sectionHeadingProps}>
              Licensing Fee Schedule
            </Typography>

            <List sx={CommonLicenseProps.bulletListProps}>
              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Licensing Fee
                </Typography>
                <List sx={CommonLicenseProps.bulletListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.subSubSectionHeadingProps}>
                      Commercial Use
                    </Typography>
                    <Typography sx={CommonLicenseProps.normalParaProps}>
                      With respect to Derivative Work for which a Customer purchases an exclusive, commercial use license, the Licensing Fee is equal to 70 percent (70%)
                      of the net receipts received by Saagas.
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>

              <ListItem sx={CommonLicenseProps.listItemProps}>
                <Typography sx={CommonLicenseProps.subSectionHeadingProps}>
                  Payment Terms
                </Typography>
                <List sx={CommonLicenseProps.bulletListProps}>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.bulletParaProps}>
                      30 days from receipt
                    </Typography>
                  </ListItem>
                  <ListItem sx={CommonLicenseProps.listItemProps}>
                    <Typography sx={CommonLicenseProps.bulletParaProps}>
                      Paid out to connected Stripe account
                    </Typography>
                  </ListItem>
                </List>
              </ListItem>
            </List>
          </Box>
        </Container>
      </ThemeProvider>
    </>
  );
};

export default CopyrightLicenseAgreementCustomer;
